import React from 'react';
import parse from 'html-react-parser';
function PrintRenderConsultation(data, id) {
  return (
    <>
      {data?.data?.consultationData?.map((item, i) => (
        <table
          width="734px"
          align="left"
          border={0}
          cellSpacing={0}
          cellPadding={0}
          style={{ marginTop: 15, whiteSpace: 'pre-line' }}
          key={i}
        >
          {item[2]?.length > 0 && (
            <thead>
              <tr width="734px">
                <th
                  width="734px"
                  style={{ fontWeight: 'bold', fontSize: 14, color: '#000' }}
                  align="left"
                >
                  {item[1]}
                </th>
              </tr>
            </thead>
          )}
          {item[2] &&
            item[2]?.map((subItem, j) => (
              <tbody key={j}>
                <tr width="734px">
                  <td
                    width="719px"
                    style={{
                      fontWeight: 'bold',
                      color: '#000',
                      paddingTop: 15,
                      paddingLeft: 15,
                    }}
                  >
                    {subItem?.label}:
                  </td>
                </tr>
                <tr width="734px">
                  <td width="719px" style={{ paddingTop: 5, paddingLeft: 15 }}>
                    {parse(subItem?.content)}
                  </td>
                </tr>
              </tbody>
            ))}
        </table>
      ))}
    </>
  );
}

export default PrintRenderConsultation;
